import React, { useState, useEffect, useRef } from 'react';
import { authFetch } from '../../utils/api';

function Stage3DMSettings() {
  const [message, setMessage] = useState(`Hi there,

Your business has great potential! 
I design custom Shopify stores that make selling easier and help turn visitors into loyal customers.

Curious how this could work for you? 
Let’s connect.`);
  const [count, setCount] = useState(1);
  const [filterDate, setFilterDate] = useState('');
  const [pendingCount, setPendingCount] = useState(null);
  const [countLoading, setCountLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const debounceRef = useRef(null);

  useEffect(() => {
    clearTimeout(debounceRef.current);
    if (!filterDate) { setPendingCount(null); return; }
    setCountLoading(true);
    debounceRef.current = setTimeout(async () => {
      try {
        const data = await authFetch(`/leads/pending-count?date=${filterDate}`);
        setPendingCount(data.count ?? 0);
      } catch { setPendingCount(null); }
      finally { setCountLoading(false); }
    }, 300);
    return () => clearTimeout(debounceRef.current);
  }, [filterDate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!message.trim() || count <= 0) {
      setStatusMessage('⚠️ Please enter a valid message and DM count.');
      setShowModal(true);
      return;
    }

    setLoading(true);
    setShowModal(false);
    setStatusMessage('');

    try {
      const body = { message, count };
      if (filterDate) body.filterDate = filterDate;
      const data = await authFetch('/send-dms', {
        method: 'POST',
        body: JSON.stringify(body)
      });

      let msg = `✔️ ${data.sentCount || 0} DMs sent successfully.`;
      if (data.errorCount > 0) msg += `\n✖️ ${data.errorCount} failed.`;

      setStatusMessage(msg);
      if (filterDate) setPendingCount(prev => Math.max(0, (prev ?? 0) - (data.sentCount || 0)));
    } catch (err) {
      setStatusMessage(err.message || '❌ Server error. Please try again.');
    } finally {
      setLoading(false);
      setShowModal(true);
    }
  };

  return (
    <div className="form-wrapper" style={{ position: 'relative' }}>
      {loading && (
        <div className="loader-overlay">
          <div className="loader">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
          </div>
          <p className="loader-text">Sending DMs...</p>
        </div>
      )}

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <p style={{ whiteSpace: 'pre-line' }}>{statusMessage}</p>
            <button className="close-btn" onClick={() => setShowModal(false)}>OK</button>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit} className="scrape-form">
        <h2 className="form-title">Stage 3: DM Automation</h2>

        <div className="form-group full-width">
          <label htmlFor="message" style={{ marginTop: '15px' }}>Custom DM Message:</label>
          <textarea
            id="message"
            rows={6}
            className="form-textarea"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>

        <div className="form-group full-width">
          <label htmlFor="count">Number of DMs to send:</label>
          <input
            id="count"
            type="number"
            className="form-input"
            value={count}
            min={1}
            onChange={(e) => setCount(parseInt(e.target.value))}
          />
        </div>

        {/* ── Date filter ── */}
        <div className="dm-date-filter-group">
          <div className="dm-date-filter-header">
            <label htmlFor="filterDate" className="dm-date-label">Filter by Lead Created Date</label>
            <span className="dm-date-hint">Optional — leave blank to send to all pending leads</span>
          </div>
          <div className="dm-date-row">
            <input
              id="filterDate"
              type="date"
              className="dm-date-input"
              value={filterDate}
              max={new Date().toISOString().split('T')[0]}
              onChange={(e) => { setFilterDate(e.target.value); setPendingCount(null); }}
            />
            {filterDate && (
              <button type="button" className="dm-date-clear"
                onClick={() => { setFilterDate(''); setPendingCount(null); }}>
                ✕ Clear
              </button>
            )}
          </div>
          {filterDate && (
            <div className={`dm-pending-badge${pendingCount === 0 ? ' dm-pending-zero' : ''}`}>
              {countLoading
                ? 'Checking leads…'
                : pendingCount === null ? ''
                : pendingCount === 0
                  ? '⚠️ No pending leads on this date'
                  : `📋 ${pendingCount} pending lead${pendingCount !== 1 ? 's' : ''} on this date`}
            </div>
          )}
        </div>

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? 'Sending...' : 'Start DM Automation'}
        </button>
      </form>
    </div>
  );
}

export default Stage3DMSettings;
